export default defineNuxtPlugin(() => {
  const { $eventBus } = useNuxtApp()
  const journey = {
    change: (info: any) => {
      $eventBus.emit('journey-change', info)
    }
  }
  return {
    provide: {
      journey
    }
  }
})
